import React from 'react'
import moment from 'moment'
import { get, isEmpty, join, unescape } from 'lodash'

import { getFormattedEventTime } from '../../utilities/events/getFormattedEventTime'
import htmlDecode from '../../utilities/content/htmlDecode'
import labels from '../../configuration/labels'
import placeholderImage from '../../assets/images/brand-placeholder.jpg'
import UnderlineArrow from '../../assets/icons/arrow-underline-right.svg'

const EventCard = ({ event }) => {
  const startDate = moment(get(event, 'activeDates.startDate', null))
  const endDate = moment(get(event, 'activeDates.endDate', null))
  const {
    categories,
    flagColor,
    flagText,
    isLocationLinkInternal,
    location,
    locationLink,
    bookingLink,
    isBookingLinkInternal,
    marketingLink,
    isInternalLink: isMarketingLinkInternal,
    title
  } = event

  const formattedEventTime = getFormattedEventTime(startDate, endDate)
  const formattedStartDate = moment(startDate).format('ll')

  return (
    <div className="event-card">
      <div className="event-card__header">
        {!startDate.startOf('day').isSame(endDate.startOf('day')) && endDate.isValid() && (
          <div className="event-banner__dates">
            <>
              <span className="date">
                <span className="month">{startDate?.format('MM')}</span>
                <span className="day">{startDate?.format('DD')}</span>
              </span>
              <span className="date-spacer">-</span>
              <span className="date">
                <span className="month">{endDate?.format('MMM')}</span>
                <span className="day">{endDate?.format('DD')}</span>
              </span>
            </>
          </div>
        )}
        <div className="event-banner__categories">
          {categories && !isEmpty(categories) && (
            <span className="category">{unescape(join(categories, ', '))}</span>
          )}
          {flagText && (
            <span
              className="flag"
              style={
                flagColor && {
                  color: flagColor
                }
              }
            >
              {flagText}
            </span>
          )}
        </div>
        <img
          className="event-image"
          alt={get(event, 'image.alt', 'event-image')}
          src={get(event, 'image.path', placeholderImage)}
        />
      </div>
      <div className="event-card__body">
        <div className="event-title-section">
          <h4 className="title">{htmlDecode(title)}</h4>
          <div className="event-schedule">
            <div>
              {formattedStartDate && <span className="event-time">{formattedStartDate}</span>}
              {startDate && formattedEventTime && <span className="vertical-divider">|</span>}
              {formattedEventTime && <span className="event-time">{formattedEventTime}</span>}
            </div>
            {location && (
              <>
                {locationLink ? (
                  <a
                    className="link event-location"
                    href={locationLink}
                    target={isLocationLinkInternal ? '_self' : '_blank'}
                    rel="noopener noreferrer"
                  >
                    {location}
                  </a>
                ) : (
                  <span className="event-location">{location}</span>
                )}
              </>
            )}
          </div>
        </div>
        <div className="section-divider" />
        <p className="description">
          {get(
            event,
            'description',
          )}
        </p>
        <div className="event-links">
          {bookingLink && (
            <a
              className="btn link-view-details get-tickets"
              href={bookingLink}
              target={isBookingLinkInternal ? '_self' : '_blank'}
              rel="noopener noreferrer"
            >
              {get(labels, 'eventCardsCtaGetTickets', 'Learn More')}
            </a>
          )}
          {marketingLink && (
            <a
              className="btn link-view-details marketing-link"
              href={marketingLink}
              target={isMarketingLinkInternal ? '_self' : '_blank'}
              rel="noopener noreferrer"
            >
              <span>
                {get(labels, 'eventCardsCtaLearnMore', 'Learn More')}
                <img src={UnderlineArrow} alt="learn more" />
              </span>
            </a>
          )}
        </div>
      </div>
    </div>
  )
}
export default EventCard
